import "core-js/modules/es.array-buffer.constructor";
import "core-js/modules/es.array-buffer.slice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/es.typed-array.uint8-array";
import "core-js/modules/es.typed-array.copy-within";
import "core-js/modules/es.typed-array.every";
import "core-js/modules/es.typed-array.fill";
import "core-js/modules/es.typed-array.filter";
import "core-js/modules/es.typed-array.find";
import "core-js/modules/es.typed-array.find-index";
import "core-js/modules/es.typed-array.for-each";
import "core-js/modules/es.typed-array.includes";
import "core-js/modules/es.typed-array.index-of";
import "core-js/modules/es.typed-array.iterator";
import "core-js/modules/es.typed-array.join";
import "core-js/modules/es.typed-array.last-index-of";
import "core-js/modules/es.typed-array.map";
import "core-js/modules/es.typed-array.reduce";
import "core-js/modules/es.typed-array.reduce-right";
import "core-js/modules/es.typed-array.reverse";
import "core-js/modules/es.typed-array.set";
import "core-js/modules/es.typed-array.slice";
import "core-js/modules/es.typed-array.some";
import "core-js/modules/es.typed-array.sort";
import "core-js/modules/es.typed-array.subarray";
import "core-js/modules/es.typed-array.to-locale-string";
import "core-js/modules/es.typed-array.to-string";
var ExpressImage = {
  compress: function compress(originFile, file, pressFileSize) {
    var _this = this;

    var maxWH = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1920;
    // 压缩
    var fileType = file.type;
    var fileSize = file.size / 1024;
    return new Promise(function (resolve) {
      var reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = function () {
        var canvas = document.createElement('canvas');
        var img = document.createElement('img');
        img.src = reader.result;

        img.onload = function () {
          var ctx = canvas.getContext('2d');

          var _dWH = _this.dWH(img.width, img.height, maxWH);

          canvas.width = _dWH.width;
          canvas.height = _dWH.height; // 清空后, 重写画布

          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          var newImgData = canvas.toDataURL('image/jpeg', 1);

          var newImgSize = _this.fileSizeKB(newImgData);

          console.log('图片尺寸太大!' + fileSize + ' >> quality 1 压缩后：' + newImgSize);

          if (newImgSize > pressFileSize) {
            for (var i = 0.95; i > 0; i -= 0.05) {
              newImgData = canvas.toDataURL('image/jpeg', Number(i.toFixed(2)));
              newImgSize = _this.fileSizeKB(newImgData);
              console.log('图片尺寸太大!' + fileSize + ' >> quality ' + i + ' 压缩后：' + newImgSize);

              if (newImgSize <= pressFileSize) {
                break;
              }
            }
          }

          var blob = _this.dataURLtoBlob(newImgData, fileType);

          var nfile = new File([blob], file.name, {
            type: fileType
          });

          if (originFile) {
            nfile.uid = originFile.uid;
            originFile.raw = nfile;
            originFile.size = nfile.size;
          }

          resolve(originFile || nfile);
        };
      };
    });
  },

  /**
   * 长宽等比缩小
   * 图像的一边(长或宽)为最大目标值
   */
  dWH: function dWH(srcW, srcH, dMax) {
    var defaults = {
      width: srcW,
      height: srcH
    };

    if (Math.max(srcW, srcH) > dMax) {
      if (srcW > srcH) {
        defaults.width = dMax;
        defaults.height = Math.round(srcH * (dMax / srcW));
        return defaults;
      } else {
        defaults.height = dMax;
        defaults.width = Math.round(srcW * (dMax / srcH));
        return defaults;
      }
    } else {
      return defaults;
    }
  },
  fileSizeKB: function fileSizeKB(dataURL) {
    var sizeKB = 0;
    sizeKB = Math.round(dataURL.split(',')[1].length * 3 / 4 / 1024);
    return sizeKB;
  },

  /**
   * 转为Blob
   */
  dataURLtoBlob: function dataURLtoBlob(dataURL, fileType) {
    var byteString = atob(dataURL.split(',')[1]);
    var mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);

    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    if (fileType) {
      mimeString = fileType;
    }

    return new Blob([ab], {
      type: mimeString,
      lastModifiedDate: new Date()
    });
  }
};
export { ExpressImage };